import React from 'react';
import styled from 'styled-components';
import { getPageMessage } from '../../shared/constants/pageMessages';

const EmptyWorkList: React.FC = () => {
  return (
    <EmptyWorkListContainer>
      {getPageMessage('NO_WORKS_FOUND')}
    </EmptyWorkListContainer>
  );
};

export default EmptyWorkList;

const EmptyWorkListContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  ${({ theme }) => theme.typography.Body_03_2};
  color: ${({ theme }) => theme.colors.color_Gray_05};
`;
